import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PerfilMenu from '../../components/MiPerfil/perfilMenu';
import Misdatos from '../../components/MiPerfil/misDatos';
import { usuarioSelector } from '../../selectors/sessionSelector';
import './index.css';

import * as pedidoActions from "../../reducers/PedidoReducer/actions";
import * as sessionActions from '../../reducers/SessionReducer/actions'

class MiPerfilContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showMisdatos: false,
        };
    }

    componentDidMount = () => {
        if (!this.props.usuario) {
            window.location.hash = "/Login"
        } else {
            /* 
            Dado que hay solo 1 opcion, la seteo por defecto. Cuando se agreguen más hay que borrar el siguiente setEstate 
            y manejarlos con los handle
            */

            this.setState({
                showMisdatos: true
            });

            this.props.setShowResumenPedido(true);
            const payload = { idUsuario: this.props.usuario.id }
            this.props.sagaFetchPedidoBorrador(payload);
        }
    }

    handleMisDatos = () => {
        this.setState({
            showMisdatos: true
        });
    }

    render() {

        return (
            <div className='miPerfil-container'>
                <div className='perfilMenu'>
                    <PerfilMenu handleMisDatos={this.handleMisDatos} />
                </div>
                <div className='perfilContenido'>
                    {this.state.showMisdatos && (
                        <Misdatos usuario={this.props.usuario} sagaCambiarContrasenia={this.props.sagaCambiarContrasenia} />
                    )}
                </div>
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            ...pedidoActions,
            ...sessionActions,
        }, dispatch);
}

function mapStateToProps(state) {
    return {
        usuario: usuarioSelector(state),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiPerfilContainer)